<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="60%"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form :model="form" ref="form" label-width="130px" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="计提月份" disabled prop="iYearMonth">
                <el-input
                  v-model="form.iYearMonth"
                  disabled
                  placeholder="请输入计提月份"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="折旧金额" disabled prop="DepreciationAmount">
                <el-input
                  v-model="form.DepreciationAmount"
                  disabled
                  placeholder="请输入折旧金额"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="Remark">
                <el-input
                  v-model="form.Remark"
                  placeholder=""
                  type="textarea"
                  rows="3"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table
          v-if="form.detailslist.length > 0"
          :data="form.detailslist"
          ref="table"
          style="width: 100%"
          height="calc(100% - 415px)"
        >
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>

          <el-table-column label="资产编号" align="center" prop="AssetCode">
          </el-table-column>
          <el-table-column label="资产名称" align="center" prop="AssetName">
          </el-table-column>
          <el-table-column
            label="折旧金额"
            align="right"
            prop="DepreciationAmount"
          >
            <template slot-scope="scope">
              {{ $tools.momenyFormat(scope.row.DepreciationAmount, 2) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Token from '@/utils/cache/TokenCache.js'

export default {
  data() {
    return {
      title: '',
      loading: false,
      token: 'Bearer ' + Token.getToken(),
      form: {
        iYearMonth: '',
        DepreciationAmount: '',
        Remark: '',
        detailslist: [],
      },
      rules: {},
      drawer: false,
    }
  },
  props: {},
  methods: {
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }
        this.loading = true
        this.$http
          .post('/AM/AM_AssetDepreciation/SaveData', this.form)
          .then((resJson) => {
            this.loading = false

            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, id, iYearMonth) {
      this.drawer = true
      this.form = {
        iYearMonth: '',
        DepreciationAmount: '',
        Remark: '',
        detailslist: [],
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      this.getInfo(id, iYearMonth)
    },
    getInfo(id, iYearMonth) {
      this.loading = true
      if (id != null) {
        this.$http
          .post('/AM/AM_AssetDepreciation/GetTheData', { id: id })
          .then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.form = resJson.Data
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      } else {
        this.$http
          .post(
            '/AM/am_asset/CalculateCurrentMonthOfDepreciation?iYearMonth=' +
              iYearMonth
          )
          .then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.form = resJson.Data
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      }
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
